<template>
  <transition name="sh-toast-fade">
    <div v-if="toast" class="sh-toast" role="status" aria-live="polite">
      <span class="sh-toast-text">{{ toast }}</span>
      <span class="sh-toast-close" aria-label="Dismiss" @click="hideToast">
        <i class="fal fa-times" aria-hidden="true"></i>
      </span>
    </div>
  </transition>
</template>

<script>
import { mapState, mapActions } from "vuex";
import "@/stylesheets/sh-messaging.css";

// Bottom-right confirmation toast for block/unblock ("User successfully
// blocked"). Driven entirely by the blockedUsers store so any page can
// render one instance and every block/unblock action lights it up.
export default {
  name: "BlockToast",
  computed: {
    ...mapState("blockedUsers", ["toast"])
  },
  methods: {
    ...mapActions("blockedUsers", ["hideToast"])
  }
};
</script>
